import { createSelector } from 'reselect';

import { TState } from '~/src/store';

const selectArticles = createSelector(
    [
      (state: TState) => state.internetReducer.sections,
    ],
    (sections) => ({
        sections,
        keys: Object.keys(sections),
    }),
);

export default selectArticles;
